import React from 'react';
import {
  TableCell,
  TextField,
  Button,
  Typography,
  Fab,
  Input,
  Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { DatePicker } from '../../DatePicker';
import { inputFieldNames } from '../../../constants';

import { Attachment as AttachmentIcon } from '@material-ui/icons';
import Attachments from '../../Attachments';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  cancelButton: {
    marginLeft: 10,
    color: theme.palette.subTitle.main
  },
  addAttachmentFab: {
    margin: theme.spacing(1),
    marginLeft: 0
  },
  fab: {
    margin: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
    width: 210,
    height: '36px !important',
    borderWidth: 1.3,
    flex: 1
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

const EditEventRecord = (props) => {
  const classes = useStyles();
  const {
    record,
    handleEditEventRecordInputChange,
    enableEditEventRecord,
    handleSaveEventRecordClick,
    handleRemoveAttachment,
    allAttachments
  } = props;

  const hiddenFileInput = React.createRef();

  const handleClick = (event) => {
    hiddenFileInput.current.children[0].click();
  };

  const onAttachmendAdded = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const newObj = {
      newlyAdded: true,
      removed: false,
      fileData: file,
      name: file.name
    };
    handleEditEventRecordInputChange(
      newObj,
      inputFieldNames.EVENT_RECORD_ATTACHMENT
    );
    hiddenFileInput.current.children[0].value = null;
  };

  return (
    <React.Fragment>
      <TableCell component="th" scope="row">
        <DatePicker
          id="eventRecordDate"
          htmlId="eventRecordDate"
          title="Date"
          handleDateChange={(date) =>
            handleEditEventRecordInputChange(date, inputFieldNames.RECORD_DATE)
          }
          selectedDate={record.recordDate}
          required={true}
        />
      </TableCell>
      <TableCell component="th" scope="row">   
      <TextField
          id="recordNotes"
          label="Next Event"
          disabled
          value= {moment(record.nextEventDate).format('DD MMM YYYY')}
          fullWidth
        /> 

     </TableCell>
      <TableCell component="th" scope="row">
        <TextField
          id="recordNotes"
          label="Notes"
          onChange={(e) =>
            handleEditEventRecordInputChange(e, inputFieldNames.RECORD_NOTES)
          }
          value= {record.notes}
          fullWidth
          multiline
          maxRows={2}
        />
      </TableCell>
      <TableCell component="th" scope="row" align="center">
        <React.Fragment>
          {/***************** Attachment ******************/}
          <Grid item xs={12} className={classes.gridItem}>
            <Typography className={classes.label}>Attachments</Typography>
          </Grid>
          <Grid item xs={12} className={classes.gridItem}>
            <Fab
              id="addAttachmentBtn"
              color="primary"
              variant="extended"
              aria-label="add"
              onClick={handleClick}
              className={`${classes.addAttachmentFab} ${classes.button}`}
            >
              <AttachmentIcon className={classes.extendedIcon} />
              Add attachment
              <Input
                type="file"
                ref={hiddenFileInput}
                multiple={false}
                onChange={onAttachmendAdded}
                style={{ display: 'none' }}
              />
            </Fab>
          </Grid>
          {allAttachments && (
            <Grid item xs={12} className={classes.gridItem}>
              <Attachments
                allAttachments={allAttachments}
                onRemoveAttachment={handleRemoveAttachment}
              />
            </Grid>
          )}
        </React.Fragment>
      </TableCell>
      <TableCell component="th" scope="row" align="center">
        <React.Fragment>
          <Button
            onClick={handleSaveEventRecordClick}
            color="primary"
            variant="outlined"
            className={classes.actionButton}
            id="saveButton"
          >
            Save
          </Button>
          <Button
            onClick={() => enableEditEventRecord(false, record.id)}
            className={classes.cancelButton}
            id="cancelButton"
          >
            Cancel
          </Button>
        </React.Fragment>
      </TableCell>
    </React.Fragment>
  );
};

export default EditEventRecord;
